import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={isOpen ? "item open" : "item"}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="heading">
        <div className="right-side">
          <p>{question}</p>
        </div>
        <div className="toggle-icon">
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </div>
      </div>
      {isOpen && <div dangerouslySetInnerHTML={{ __html: answer }} />}
    </div>
  );
};

export default FaqItem;
